/**
 * Snapshot review for procedure node copy / move / delete audits only.
 * Routed at `/audit-trail/reviewcopymovedelete/:audit_trail_id`; add/edit/save reviews
 * remain on `ReviewLayout` at `/audit-trail/review/:audit_trail_id`.
 *
 * UI is shared with {@link ./ReviewLayout} today; this module is the dedicated entry
 * so node-change behaviour can evolve without impacting general review.
 */
import ReviewLayout from "./ReviewLayout";

export default ReviewLayout;

